import { FC } from 'react'
import { useHistory } from 'react-router'
import { IonRouterLink } from '@ionic/react'

import { UserName } from '@components/atoms/UserName'
import { FollowButton } from '@components/molecules/FollowButton'
import { ListItem } from '@components/molecules/ListItem'

import { IUser } from '@services/findUsers'
import { UserInfo } from '@/services/user'
import { ChatStatus } from '@/lib/hooks/chat/useChat'
import { useUnlockChatModal } from '@/lib/hooks/chat/useUnlockChatModal'
import { queryClient } from '@/lib/queryClient'

import { QueryKeys } from '@/enums'

export interface IUsersListItemProps {
  item: IUser
  linkToMessages?: boolean
}
export const UsersListItem: FC<IUsersListItemProps> = ({
  item,
  linkToMessages,
}) => {
  const { presentUnlockChatModal } = useUnlockChatModal({
    userInfo: {
      id: item.id,
      username: item.username,
    } as UserInfo,
    amount: item?.chat?.price,
  })

  const history = useHistory()
  if (linkToMessages) {
    const chatData: { status: ChatStatus } = queryClient.getQueryData([
      QueryKeys.ChatStatus,
      item.id,
    ])
    const onClick = (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation()
      if (chatData?.status !== 'UNLOCKED' && item?.chat.status === 'LOCKED') {
        presentUnlockChatModal()
        return
      }
      history.push(`/messages/${item.id}`)
    }

    return (
      <ListItem key={item.id} item={item}>
        <div
          className="w-full h-full flex cursor-pointer justify-center"
          onClick={onClick}
        >
          <div className="w-full h-full flex flex-wrap items-center justify-between pr-2">
            <UserName
              className="block font-medium text-sm"
              name={item.username}
            />
            {chatData?.status === 'UNLOCKED' ? (
              <img src="/unlocked-icon-white.svg" alt="unlocked" />
            ) : item?.chat.status === 'LOCKED' ? (
              <img src="/locked-icon-green.svg" alt="locked" />
            ) : (
              item?.chat.status === 'UNLOCKED' && (
                <img src="/unlocked-icon-white.svg" alt="unlocked" />
              )
            )}
          </div>
        </div>
      </ListItem>
    )
  }

  return (
    <ListItem key={item.id} item={item}>
      <div className="w-full flex flex-wrap items-center justify-between pr-2">
        <IonRouterLink
          className="max-w-[60%]"
          routerLink={`/@${item.username}`}
        >
          <UserName
            className="block font-medium text-sm"
            name={item.username}
          />
          <span className="text-xs">{item.displayName}</span>
        </IonRouterLink>
        <FollowButton
          userId={item.id}
          followStatus={item.followStatus}
          size="small"
          username={item.username}
        />
      </div>
    </ListItem>
  )
}
